/**
 * Verti DEU PL API
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * (german: Stellung im Beruf)   (bipro-partner::StellungImBeruf)     * `Employee`                - german: Angestellte/er   * `Worker`                  - german: Arbeiter/in   * `Official`                - german: Beamter/Beamtin   * `SelfEmployed`            - german: Selbständige/r   * `Pensioner`               - german: Rentner/in   * `Pupil`                   - german: Schüler/in   * `Student`                 - german: Student/in   * `HousePrivatier`          - german: Hausmann/-frau, Privatier   * `NotWorking`              - german: nicht erwerbstätig   * `ProfessionalSoldier`     - german: Berufssoldat/in   * `Apprentice`              - german: Auszubildende/r   * `Farmer`                  - german: Landwirt
 */
export const OccupationKind = {
  Employee: 'Employee',
  Worker: 'Worker',
  Official: 'Official',
  SelfEmployed: 'SelfEmployed',
  Pensioner: 'Pensioner',
  Pupil: 'Pupil',
  Student: 'Student',
  HousePrivatier: 'HousePrivatier',
  NotWorking: 'NotWorking',
  ProfessionalSoldier: 'ProfessionalSoldier',
  Apprentice: 'Apprentice',
  Farmer: 'Farmer',
} as const;
export type OccupationKind = (typeof OccupationKind)[keyof typeof OccupationKind];
